var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div>\n    <div>\n        <div>\n            <div class=\"favorites__item\">\n                <a href=\""
    + alias2(alias1(depth0, depth0))
    + "\" class=\"favorites__link\">"
    + alias2(alias1(depth0, depth0))
    + "</a>\n                <button type=\"button\" class=\"favorites__remove\">\n                    <i class=\"material-icons\" data-name=\""
    + alias2(alias1(depth0, depth0))
    + "\">close</i>\n                    <span class=\"visually-hidden\">Remove from favorites</span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});